module.exports = __webpack_public_path__ + "static/media/cross-gray-filled.0bf904e5.png";